import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";

export default function DeepLink() {
  const { token } = useParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/t/${token}`);
        localStorage.setItem("doenies_token", data.session_token);
        if (data.org_id) localStorage.setItem("slackr_org", data.org_id);
        const q = data.target_id ? `?task=${encodeURIComponent(data.target_id)}` : "";
        window.location.href = `${data.dest || "/vandaag"}${q}`;
      } catch (e) {
        setError(e.response?.data?.detail || "Deze link werkt niet meer.");
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-cream p-6" data-testid="deeplink-page">
      <div className="brutal rounded-2xl bg-white p-8 max-w-sm w-full text-center">
        {!error ? (
          <>
            <Loader2 className="w-8 h-8 animate-spin mx-auto mb-4 text-brand-violet" strokeWidth={2.5} />
            <p className="font-head font-bold text-lg">Slackr openen…</p>
            <p className="text-sm text-brand-ink/60 mt-1">Je taak wordt geladen.</p>
          </>
        ) : (
          <>
            <p className="font-head font-black text-xl mb-2">Oeps</p>
            <p className="text-sm text-brand-ink/70">{error}</p>
            <a href="/vandaag" data-testid="deeplink-open-app" className="inline-block mt-5 brutal-sm brutal-press rounded-full px-5 py-2.5 bg-brand-violet text-white font-bold">Open Slackr</a>
          </>
        )}
      </div>
    </div>
  );
}
